import React, { PropsWithChildren, useMemo, useState } from 'react';
import PageContext, { PageAction } from './PageContext';

const PageProvider: React.FC<PropsWithChildren> = (props) => {
  const [actions, setActions] = useState<PageAction[]>([]);
  const value = useMemo(
    () => ({
      actions,
      setActions,
    }),
    [actions],
  );

  return <PageContext.Provider value={value}>{props.children}</PageContext.Provider>;
};

export default React.memo(PageProvider);
